<template>
    <input
        v-if="tpfield === 'CPF'"
        type="text"
        class="input-center"
        :maxlength="maxlength || 14"
        :value="modelValue"
        v-cpf
        @input="onInput"
    />

    <input
        v-else-if="tpfield === 'CNPJ'"
        type="text"
        class="input-center"
        :maxlength="maxlength || 18"
        :value="modelValue"
        v-cnpj
        @input="onInput"
    />

    <input
        v-else-if="tpfield === 'CEP'"
        type="text"
        class="input-center"
        :maxlength="maxlength || 9"
        :value="modelValue"
        v-cep
        @input="onInput"
    />

    <input
        v-else-if="tpfield === 'DATA'"
        type="date"
        :value="modelValue"
        @input="onInput"
    />

    <input
        v-else-if="tpfield === 'NUMERO'"
        type="number"
        class="input-center"
        :maxlength="maxlength || null"
        :value="modelValue"
        @input="onInput"
    />

    <input
        v-else-if="tpfield === 'EMAIL'"
        type="email"
        :maxlength="maxlength || null"
        :value="modelValue"
        @input="onInput"
    />

    <input
        v-else-if="tpfield === 'FONE' || tpfield === 'TELEFONE'"
        type="text"
        class="input-center"
        :maxlength="maxlength || 15"
        :value="modelValue"
        v-phone
        @input="onInput"
    />

    <input
        v-else
        type="text"
        :maxlength="maxlength || null"
        :value="modelValue"
        @input="onInput"
    />
</template>

<script setup>
defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    tpfield: {
        type: String,
        default: 'TEXTO'
    },
    maxlength: {
        type: Number,
        default: null
    }
});

const emit = defineEmits(['update:modelValue']);

function onInput(event) {
    emit('update:modelValue', event.target.value);
}
</script>